<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="dialogFormVisible = true" :disabled="!power.goods_add">新增</el-button>
                <el-button @click="delMultiple" type="danger" size="small" icon="iconfont icon-shanchu shuaxin" :disabled="!power.goods_del">删除</el-button>
            </el-col>

            <!-- search start  -->
            <el-col :span="24" class="search-content">
                <div class="search-item" style="width: 150px;">
                    <el-select v-model="data.is_put" placeholder="请选择状态" size="small">
                        <el-option
                            v-for="item in [
                              {id: 0, title: '所有状态'},
                              {id: 1, title: '上架'},
                              {id: 2, title: '下架'},
                            ]"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item" style="width: 150px;">
                    <el-select v-model="data.is_group" placeholder="请选择团购" size="small">
                        <el-option
                            v-for="item in [
                              {id: 0, title: '不限团购'},
                              {id: 1, title: '非团购'},
                              {id: 2, title: '团购'},
                            ]"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item" style="width: 150px;">
                    <el-select v-model="data.is_rush" placeholder="请选择抢购" size="small">
                        <el-option
                            v-for="item in [
                              {id: 0, title: '不限抢购'},
                              {id: 1, title: '非抢购'},
                              {id: 2, title: '抢购'},
                            ]"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item" style="width: 150px;">
                    <el-select v-model="data.category_id" placeholder="请选择商品分类" size="small">
                        <el-option
                            v-for="item in categoryList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item">
                    <el-input v-model="data.id" size="small" type="number" placeholder="请输入商品id" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-input v-model="data.title" size="small" placeholder="请输入商品标题" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col>
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="title" label="商品标题" width="300"></el-table-column>
                    <el-table-column prop="category_title" label="商品分类" width="100"></el-table-column>
                    <el-table-column prop="cover" label="封面" width="80">
                      <template slot-scope="scope">
                        <el-popover
                          placement="right"
                          width="200"
                          trigger="click">
                          <el-image
                            style="width: 200px; height: 200px"
                            :src="scope.row.cover">
                          </el-image>
                          <el-image
                            slot="reference"
                            style="width: 50px; height: 50px; cursor: pointer;"
                            :src="scope.row.cover">
                          </el-image>
                        </el-popover>
                      </template>
                    </el-table-column>
                    <el-table-column prop="price" label="售价" width="80"></el-table-column>
                    <el-table-column prop="market_price" label="市场价" width="80"></el-table-column>
                    <el-table-column prop="integral" label="所需积分" width="80">
                      <template slot-scope="scope">
                        <span>{{scope.row.integral}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="stock_num" label="库存" width="80"></el-table-column>
                    <el-table-column prop="company" label="单位" width="80"></el-table-column>
                    <el-table-column prop="is_group" label="是否团购" width="80">
                      <template slot-scope="scope">
                        <span v-if="scope.row.is_group == 2" style="color: #67C23A;">团购</span>
                        <span v-else style="color: #F56C6C;">否</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="is_rush" label="是否抢购" width="80">
                      <template slot-scope="scope">
                        <span v-if="scope.row.is_rush == 2" style="color: #67C23A;">抢购</span>
                        <span v-else style="color: #F56C6C;">否</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="is_put" label="状态" width="80">
                      <template slot-scope="scope">
                        <el-switch
                          :disabled="!power.goods_add"
                          v-model="scope.row.is_put"
                          @change="switchChange(scope.row)"
                          active-color="#13ce66"
                          inactive-color="#ff4949"
                          :active-value="1"
                          :inactive-value="2">
                        </el-switch>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="180">
                        <template slot-scope="scope">
                            <el-button @click="editTmp(scope.row, 1)" :disabled="scope.row.is_rush == 2 || !power.goods_add" icon="iconfont iconicon-test shuaxin" type="primary" size="mini" plain>设置团购</el-button>
                            <el-button @click="editTmp(scope.row, 2)" :disabled="scope.row.is_group == 2 || !power.goods_add" icon="iconfont iconqiang shuaxin" type="primary" size="mini" plain>设置抢购</el-button>
                            <el-button @click="editPush(scope.row.id)" icon="iconfont icon-bianji shuaxin" type="primary" size="mini" plain :disabled="!power.goods_add">编辑</el-button>
                            <el-button @click="del(scope.row.id)" icon="iconfont icon-shanchu shuaxin" size="mini" type="danger" plain :disabled="!power.goods_del">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="dialogClose" width="570px" center>
            <el-form v-if="actType == 1" :model="form" ref="form" class="dialog-form" @submit.native.prevent>
                <el-form-item label="团购"
                    :label-width="formLabelWidth"
                    prop="is_group"
                    :rules="[
                    { required: true, message: '请选择状态', trigger: 'blur' }
                    ]">
                    <el-radio v-model="form.is_group" :label="2" border>开启</el-radio>
                    <el-radio v-model="form.is_group" :label="1" border>关闭</el-radio>
                </el-form-item>
                <el-form-item label="团购时间"
                    :label-width="formLabelWidth"
                    prop="group_time"
                    :rules="[
                      { required: form.is_group == 2, message: '请选择团购时间', trigger: 'blur' }
                    ]">
                    <el-date-picker
                      v-model="form.group_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="团购价格"
                    :label-width="formLabelWidth"
                    prop="group_price"
                    :rules="[
                    { required: form.is_group == 2, message: '请输入团购价格', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.group_price" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="团购数量"
                    :label-width="formLabelWidth"
                    prop="group_num"
                    :rules="[
                    { required: form.is_group == 2, message: '请输入团购数量', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.group_num" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>

            <el-form v-if="actType == 2" :model="form" ref="form" class="dialog-form" @submit.native.prevent>
                <el-form-item label="抢购"
                    :label-width="formLabelWidth"
                    prop="is_rush"
                    :rules="[
                    { required: true, message: '请选择状态', trigger: 'blur' }
                    ]">
                    <el-radio v-model="form.is_rush" :label="2" border>开启</el-radio>
                    <el-radio v-model="form.is_rush" :label="1" border>关闭</el-radio>
                </el-form-item>
                <el-form-item label="抢购时间"
                    :label-width="formLabelWidth"
                    prop="rush_time"
                    :rules="[
                      { required: form.is_rush == 2, message: '请选择抢购时间', trigger: 'blur' }
                    ]">
                    <el-date-picker
                      v-model="form.rush_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="抢购价格"
                    :label-width="formLabelWidth"
                    prop="rush_price"
                    :rules="[
                    { required: form.is_rush == 2, message: '请输入抢购价格', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.rush_price" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="抢购数量"
                    :label-width="formLabelWidth"
                    prop="rush_num"
                    :rules="[
                    { required: form.is_rush == 2, message: '请输入抢购数量', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.rush_num" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addData('form')">确 定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {GoodsIndex, GoodsAdd, GoodsDel} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    category_id: '',
                    title: '',
                    id: '',
                    is_group: '',
                    is_rush: '',
                    is_put: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "新增商品",
                formLabelWidth: "120px",
                form: {},
                multipleSelection: [],
                loadingImage: false,
                actType: 1,
                switchData: null,
                categoryList: []
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                GoodsIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                        this.categoryList = res.data.categoryList
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            addData(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        GoodsAdd(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            editPush(id) {
              this.$router.push({name:'goods-add', params: {id: id}})
            },
            editTmp(data, type) {
              this.actType = type
              if (type == 1) {
                let group_time = []
                if (data.group_time_start != null && data.group_time_end != null) {
                  group_time = [data.group_time_start, data.group_time_end]
                }

                this.form = {
                    id: data.id,
                    is_group: data.is_group,
                    group_price: data.group_price == 0 ? '' : data.group_price,
                    group_num: data.group_num == 0 ? '' : data.group_num,
                    group_time: group_time,
                }
                this.dialogTitle = '设置团购'
              } else if (type == 2) {
                let rush_time = []
                if (data.rush_time_start != null && data.rush_time_end != null) {
                  rush_time = [data.rush_time_start, data.rush_time_end]
                }

                this.form = {
                    id: data.id,
                    is_rush: data.is_rush,
                    rush_price: data.rush_price == 0 ? '' : data.rush_price,
                    rush_num: data.rush_num == 0 ? '' : data.rush_num,
                    rush_time: rush_time,
                }
                this.dialogTitle = '设置抢购'
              }

              this.dialogFormVisible = true
            },
            dialogClose() {
                this.initForm()
            },
            initForm() {
                // 初始化，form数据
                this.form = {}
                // 重置字段验证
                this.$refs["form"].resetFields();
                this.dialogTitle = ""
            },
            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },
            delMultiple() {
                if (this.multipleSelection.length == 0) {
                    this.$message.error("请至少选择一项你要删除的项");
                    return
                }
                this.del(this.multipleSelection)
            },
            del(id) {
                this.$confirm("确定要执行删除操作吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "error"
                }).then(() => {
                    GoodsDel({id: id}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            },
            switchChange(row) {
              GoodsAdd({id: row.id, is_put: row.is_put}).then((res) => {
                  if (res.code == 200) {
                      this.$message.success(res.msg);
                  } else {
                      this.$message.error(res.msg);
                  }
              })
            }
        }
    }
</script>

<style>
</style>
